import React, { useEffect, useMemo, useState } from 'react'
import cx from 'classnames'
import styles from './tabs-icon.module.scss'

type ITabsProps = {
  activeIndex?: number
  fitWidth?: boolean
  children: React.ReactElement[]
}

type ITabPanelProps = {
  label: string
  tabRender: React.ReactElement<{ color?: string }>
  children: React.ReactNode
}

type ITabData = ITabPanelProps & { index: number; value: string }

const TabsIcon = (props: ITabsProps) => {
  const { activeIndex: incomingActiveIndex = 0, fitWidth = true, children } = props
  const [activeIndex, setActiveIndex] = useState(incomingActiveIndex)
  const [tabDataList, setTabDataList] = useState<ITabData[]>([])

  useEffect(() => {
    const list: ITabData[] = []
    let index = 0
    React.Children.forEach(children, (element) => {
      if (!React.isValidElement(element)) return
      const { label, tabRender, children } = element.props as ITabPanelProps
      list.push({
        index: index++,
        label,
        value: label, // ¯\_/¯
        tabRender,
        children,
      })
    })
    setTabDataList(list)
  }, [children])

  return (
    <>
      <div className={cx(styles.tabList)}>
        {/* Tab header style */}
        <div className={cx(styles.tabHeader)}>
          {tabDataList.map((tab, index) => (
            <div key={tab.index} className={cx('flex w-full justify-center')}>
              <div
                className={cx(
                  styles.tab,
                  tab.index === activeIndex ? styles.tabActive : styles.tabInactive,
                  index === 0 && styles.tabFirst,
                )}
                onClick={() => setActiveIndex(tab.index)}
              >
                {React.cloneElement(tab.tabRender, { color: tab.index === activeIndex ? '#FAB23D' : 'white' })}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Tab content */}
      <div className={cx(styles.tabPanelArea)}>
        {tabDataList.map((tab) => (
          <div key={tab.index} className={tab.index == activeIndex ? 'flex justify-center' : 'hidden'}>
            {tab.children}
          </div>
        ))}
      </div>
    </>
  )
}

const TabContent = (props: ITabPanelProps) => {
  return <div>{props.children}</div>
}

export default Object.assign(TabsIcon, {
  Panel: TabContent,
})
